import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy, OnDestroy, Inject, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { formatDate, CurrencyPipe } from '@angular/common';

import { CustomDatePickerComponent } from '../custom-date-picker/custom-date-picker.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { TruckAccountInfo } from '../../utils/truck-account-info';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatInputModule } from '@angular/material/input';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';

export interface PeriodicElement {
  currentDue: string;
  accno: any;
  RegularDue: string;
  paymentDate: string;
  currentDueDate: string
}



const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'MM/DD/YYYY'
  },
  display: {
    dateInput: 'MMM DD,YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11Label: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

@Component({
    selector: 'div.dtf-onlinepaymenttable',
    imports: [SharedTranslateModule, MatTableModule, MatButtonToggleModule, MatInputModule, MatSortModule, ReactiveFormsModule, FormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule],
    templateUrl: './online-payment-table.component.html'
})
export class OnlinePaymentTableComponent implements OnInit {
  exampleHeader = CustomDatePickerComponent;
  @ViewChild('picker')
  datePicker!: MatDatepicker<Date>;
  @ViewChild('myInput') myInput: ElementRef

  @ViewChildren('myInput1') myInput1: QueryList<ElementRef<HTMLInputElement>>
  @Input() tableData: any[];
  @Input() slectedRow: any
  @Input() continueBoolean: boolean = false
  @Output() dataEmit = new EventEmitter<string>();
  @Input() step1: boolean
  @Input() step2: boolean
  @Input() step3: boolean
  @Input() displayedColumns: string[]
  submitted: boolean
  currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
  paymentDate = new Date()

  today = new Date()

  dataSource = new MatTableDataSource<any>();
  dataSourceforSelectedRow = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  statementUrl: string;

  constructor(private currencyPipe:CurrencyPipe,private cdr: ChangeDetectorRef, private _dateAdapter: DateAdapter<Date>,
    @Inject(MAT_DATE_LOCALE) private dateLocale: string, ) {
    this._dateAdapter.setLocale('en');
    // this._dateAdapter.setDisplayFormat(CUSTOM_DATE_FORMAT)
  }

  ngOnInit(): void {

    this.dataSource.data = this.tableData
    //  this.dataSourceforSelectedRow.data=this.slectedRow

  }

  // this method is used for applying custom style for calender for weekend color
  shouldApplyCustomStyle(date: any): boolean {
    const dayOfWeek = this._dateAdapter.getDayOfWeek(date);
    return dayOfWeek === 6 || dayOfWeek == 0
  }

  // this method is for custom class of calender/date picker
  customDateClass = (date: Date) => {

    if (this.shouldApplyCustomStyle(date)) {
      return 'custom-day'

    }
    return '';
  }

  //  this method get called on change of continueBoolean variable
  ngOnChanges(changes: SimpleChanges) {

    if (changes['continueBoolean'] && changes['continueBoolean']['currentValue']) {
      this.submitted = changes['continueBoolean']['currentValue']
      this.tableData = this.dataSource.data
      this.dataEmit.emit(JSON.stringify(this.tableData))
    }
    else {
      this.dataSource.data = this.tableData
    }
  }

  // this method get called on click of select All button from table
  selectAll(event) {
    if (event.target.checked) {
      this.dataSource.data.forEach(item => {
        item.checked = true;
      })
    } else {
      this.dataSource.data.forEach(item => {
        item.checked = false;
      })
    }

  }

  // this method get called on click of any row from the table
  rowSelect(row: any) {

    let index = this.dataSource.data.findIndex(obj => obj.acctNumber === row.acctNumber)
    this.dataSource.data[index]['checked'] = !this.dataSource.data[index]['checked']



  }

  rowSelectforInvoice(row: any) {

    let index = this.dataSource.data.findIndex(obj => obj.invoiceNumber === row.invoiceNumber)
    this.dataSource.data[index]['checked'] = !this.dataSource.data[index]['checked']



  }
  // this method get called to validate the decimal value 

  validateDecimal(event, value, element,paymentType) {
    let index= this.dataSource.data.findIndex((obj: any) => obj.acctNumber === element.acctNumber)
    let inputEle= this.myInput1.toArray()[index]
    const inputPosition = inputEle.nativeElement.selectionStart


    if (event.charCode >= 48 && event.charCode <= 57) {
      if (value.includes('.')) {
        let dotPosition = value.indexOf('.')
        let arr = value.split('.')
        if (dotPosition >= inputPosition) {
          return true
        }
        if (dotPosition < inputPosition) {
          if (arr[1].length < 2) {
            return true
          }
        }

      } else {
        return true;
      }
      return false;
    } else if (event.charCode == 46 && !value.includes('.')) {

      let lastIndex=value.length
      if(lastIndex>inputPosition+2){
        if(paymentType=="online"){
          element.paymentDueAmount=value.slice(0,  (inputPosition))+"."+value.slice(inputPosition, inputPosition+2)
        }else{
          element.regularAmount=value.slice(0,  (inputPosition))+"."+value.slice(inputPosition, inputPosition+2)
        }
        
        return false;
      }
      return true;
    }
    else {
      return false;
    }

  }
  convertToDecimal(element) {
    if (element.paymentDueAmount != "") {
      let index = this.dataSource.data.findIndex(obj => obj.acctNumber === element.acctNumber);
      this.dataSource.data[index].paymentDueAmount = Number(element.paymentDueAmount).toFixed(2);
     // this.dataSource.data[index].paymentDueAmount = this.currencyPipe.transform(element.paymentDueAmount, 'USD','','1.2-2')
    }
    
  }
  convertToRgularDecimal(element) {
    if (element.regularAmount != "") {
      let index = this.dataSource.data.findIndex(obj => obj.acctNumber === element.acctNumber);
     this.dataSource.data[index].regularAmount = Number(element.regularAmount).toFixed(2)
       //this.dataSource.data[index].regularAmount = this.currencyPipe.transform(element.regularAmount, 'USD','','1.2-2')

    }
  }
  // this method gets called on entering date, month or year in input box instead of using date picker
  onChangePaymentDate(event: any, modifiedRow, mode) {
    let month = formatDate(modifiedRow.paymentDate, 'MM', 'en-US')
    let day = formatDate(modifiedRow.paymentDate, 'dd', 'en-US')
    let year = formatDate(modifiedRow.paymentDate, 'yyyy', 'en-US')
    let index = this.dataSource.data.findIndex(obj => obj.acctNumber === modifiedRow.acctNumber)
    if (mode == 'month') {
      this.dataSource.data[index].paymentDate = new Date(event.target.value + "/" + day + "/" + year)
    } else if (mode == 'day') {
      this.dataSource.data[index].paymentDate = new Date(month + '/' + event.target.value + "/" + year)
    } else {
      this.dataSource.data[index].paymentDate = new Date(month + '/' + day + "/" + event.target.value)
    }


  }

  onChangeEndDate(event: any, modifiedRow, mode) {
    let month = formatDate(modifiedRow.maturityDate, 'MM', 'en-US')
    let day = formatDate(modifiedRow.maturityDate, 'dd', 'en-US')
    let year = formatDate(modifiedRow.maturityDate, 'yyyy', 'en-US')
    let index = this.dataSource.data.findIndex(obj => obj.acctNumber === modifiedRow.acctNumber)
    if (mode == 'month') {
      this.dataSource.data[index].maturityDate = new Date(event.target.value + "/" + day + "/" + year)
    } else if (mode == 'day') {
      this.dataSource.data[index].maturityDate = new Date(month + '/' + event.target.value + "/" + year)
    } else {
      this.dataSource.data[index].maturityDate = new Date(month + '/' + day + "/" + event.target.value)
    }
  }

  // Date picker fnctionality
  dateClass = (d: Date) => {
    const date = d.getDay();
    // Highlight saturday and sunday.
    return (date === 0 || date === 6) ? 'highlight-dates' : undefined;
  }

  addEvent(input, event) {
    let index = this.tableData.findIndex((obj: any) => obj.acctNumber === input.acctNumber)
    this.tableData[index]['paymentDay'] = formatDate(event.value, 'dd', 'en-US')
    this.tableData[index]['paymentMonth'] = formatDate(event.value, 'MM', 'en-US')
    this.tableData[index]['paymentYear'] = formatDate(event.value, 'yyyy', 'en-US')


  }
  addEndEvent(input, event) {
    let index = this.tableData.findIndex((obj: any) => obj.acctNumber === input.acctNumber)
    this.tableData[index]['endDay'] = formatDate(event.value, 'dd', 'en-US')
    this.tableData[index]['endMonth'] = formatDate(event.value, 'MM', 'en-US')
    this.tableData[index]['endYear'] = formatDate(event.value, 'yyyy', 'en-US')
  }
  onClickInvoiceAmount(event) {
    this.statementUrl = window.origin + '/opsweb/Statemet-payment-invoice'
    event.preventDefault();
    window.open(this.statementUrl, '', 'width=680,height=600,left=20,top=200')

  }

  replaceCommas(element){
  element.paymentDueAmount= element.paymentDueAmount.replaceAll(',','')
  }

  replaceCommasForRegular(element){
    element.regularAmount= element.regularAmount.replaceAll(',','')
    }
}



